<template>
    <div class="form-container">
      <h2>Formulario de Registro de Empleados a nomina</h2>
      <form @submit.prevent="submitForm">
        <div class="form-group">
          <label for="cedula">Cédula:</label>
          <input type="text" id="cedula" v-model="empleado.cedula" required />
        </div>
        <div class="form-group">
          <label for="nombre">Nombre Completo:</label>
          <input type="text" id="nombre" v-model="empleado.nombre" required />
        </div>
        <div class="form-group">
          <label for="fecha_nacimiento">Fecha de Nacimiento:</label>
          <input
            type="date"
            id="fecha_nacimiento"
            v-model="empleado.fecha_nacimiento"
            required
          />
        </div>
        <div class="form-group">
          <label for="eps">EPS:</label>
          <input type="text" id="eps" v-model="empleado.eps" required />
        </div>
        <div class="form-group">
          <label for="tipo_sangre">Tipo de Sangre:</label>
          <input
            type="text"
            id="tipo_sangre"
            v-model="empleado.tipo_sangre"
            required
          />
        </div>
        <div class="form-group">
          <label for="contacto">Contacto:</label>
          <input type="tel" id="contacto" v-model="empleado.contacto" required />
        </div>
        <div class="form-group">
          <label for="contacto_emergencia">Contacto de Emergencia:</label>
          <input
            type="tel"
            id="contacto_emergencia"
            v-model="empleado.contacto_emergencia"
            required
          />
        </div>
        <div class="form-group">
          <label for="fecha_ingreso">Fecha de Ingreso:</label>
          <input
            type="date"
            id="fecha_ingreso"
            v-model="empleado.fecha_ingreso"
            required
          />
        </div>
        <div class="form-group">
          <label for="tipo_contrato">Tipo de Contrato:</label>
          <select id="tipo_contrato" v-model="empleado.tipo_contrato" required>
            <option value="">Seleccione...</option>
            <option value="Tiempo Completo">OBRA LABOR</option>
            <option value="Medio Tiempo">INDEFINIDO</option>
            <option value="Contrato por Proyecto">PRESTACIÓN DE SERVICIOS</option>
          </select>
        </div>
        <div class="buttons">
          <button id="enviar" type="submit">Editar</button>
          <button id="cancelar" @click="devolver()">Cancelar</button>
        </div>
      </form>
    </div>
  </template>
      
  <script>
  import HttpService from "../../Servicios/HttpService";
  import Swal from "sweetalert2";
  
  export default {
    props: ["id"],
    data() {
      return {
        empleado: {
          cedula: "",
          nombre: "",
          fecha_nacimiento: "",
          eps: "",
          tipo_sangre: "",
          contacto: "",
          contacto_emergencia: "",
          fecha_ingreso: "",
          tipo_contrato: "",
        },
      };
    },
    mounted() {
      this.ObtenerPorId();
    },
  
    methods: {
      devolver() {
        this.$router.push({
          name: "NominaEmpleados",
        });
      },
  
      submitForm() {
        let payload = {
          accion: "editarEmpleadoNomina",
          empleado: this.empleado,
          id: this.$route.params.id,
        };
        HttpService.registrar("reportes.php", payload).then((registrado) => {
          if (registrado) {
            Swal.fire({
              title: "Datos editados de ",
              text: this.empleado.nombre,
              icon: "success",
              confirmButtonText: "Aceptar",
            }).then(() => {
              this.devolver();
            });
          }
        });
      },
  
      ObtenerPorId() {
        let payload = {
          accion: "obtenerEmpleadoId",
          id: this.$route.params.id,
        };
        HttpService.obtenerConConsultas("reportes.php", payload).then(
          (empleado) => {
            this.empleado = empleado[0];
          }
        );
      },
  
      
    },
  };
  </script>
      
      <style scoped>
  .form-container {
    max-width: 500px;
    margin: 0 auto;
    padding: 20px;
    border: 1px solid #ccc;
    border-radius: 5px;
  }
  
  .form-group {
    margin-bottom: 20px;
  }
  
  label {
    display: block;
    font-weight: bold;
  }
  
  input[type="text"],
  input[type="date"],
  input[type="tel"],
  select {
    width: 100%;
    padding: 8px;
    border: 1px solid #ccc;
    border-radius: 4px;
    box-sizing: border-box;
  }
  
  button {
    margin-right: 10px; /* Espacio entre los botones */
    color: white;
    padding: 10px 20px;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    font-size: 16px;
  }
  
  #enviar {
    background-color: #4caf50;
  }
  
  #cancelar {
    background-color: #eb535b;
  }
  
  button:hover {
    background-color: #45a049;
  }
  </style>